<script>
    import modals from '../../state/modals';

    export let surveys;
</script>

<style>
    .surveys {
        display: flex;
        flex-flow: row wrap;
        padding: 10px 0 10px 10px;
    }

    .survey:not(:last-child) {
        margin-right: 10px;
    }

    .survey {
        cursor: pointer;
        width: 250px;
        border-radius: 8px;
        padding: 10px;
        user-select: none;
        background: white;
        box-shadow: 0 0 6px #dcdcdc, inset 0 5px dodgerblue;
    }

    .survey:hover {
        box-shadow: 0 0 6px #c7c7c7, inset 0 5px dodgerblue;
    }

    .survey:active {
        box-shadow: 0 0 6px #5cafff, inset 0 5px dodgerblue;
    }

    .survey small {
        display: block;
        /* line-height: 11px; */
        font-size: 11px;
        font-weight: 600;
    }

    .survey p {
        height: 40px;
        line-height: 20px;
        font-size: 15px;
        font-weight: 300;
        overflow: hidden;
    }
</style>

<div class="surveys">
    {#each surveys as survey}
        <div class="survey" on:click={() => modals.toggleSurveyModal(survey)}>
            <small>Anketa</small>
            <p title={survey.sur_question}>{survey.sur_question}</p>
        </div>
    {/each}
</div>